import { getFeatureFlag, isValidUrl } from "@sinch/feature-flags";

export const CROSS_DOMAIN_SHARED_STORAGE_IFRAME_ID =
  "cross-domain-shared-storage";

const getCrossDomainSharedStorageIframe =
  async (): Promise<HTMLIFrameElement> => {
    const iframeSrc = getFeatureFlag(
      "crossDomainSharedStorage",
      isValidUrl,
      "https://shared-storage.app.sinch.com"
    );

    const existingFrame = window.document.getElementById(
      CROSS_DOMAIN_SHARED_STORAGE_IFRAME_ID
    );
    if (existingFrame && existingFrame instanceof HTMLIFrameElement)
      return existingFrame;

    return new Promise((res) => {
      const iframe = window.document.createElement("iframe");
      iframe.id = CROSS_DOMAIN_SHARED_STORAGE_IFRAME_ID;
      iframe.src = iframeSrc;
      iframe.style.display = "none";
      iframe.onload = () => res(iframe);
      window.document.body.appendChild(iframe);
    });
  };

export const appendCrossDomainStorageValue = async (
  key: string,
  value: string
) => {
  const targetIframe = await getCrossDomainSharedStorageIframe();
  if (targetIframe.contentWindow) {
    targetIframe.contentWindow.postMessage(
      {
        key,
        action: "append",
        value,
      },
      "*"
    );
  }
};

export const getCrossDomainStorageValue = async (
  key: string
): Promise<string> => {
  const targetIframe = await getCrossDomainSharedStorageIframe();
  return new Promise((res, rej) => {
    setTimeout(() => rej("timeout"), 1000);
    if (targetIframe.contentWindow) {
      window.addEventListener(
        "message",
        function listener(e: MessageEvent<unknown>) {
          const { data } = e;
          if (
            !!data &&
            typeof data === "object" &&
            "key" in data &&
            typeof data.key === "string" &&
            data.key === key &&
            "value" in data &&
            typeof data.value === "string"
          ) {
            res(data.value);
            window.removeEventListener("message", listener);
          }
        }
      );

      targetIframe.contentWindow.postMessage(
        {
          key,
          action: "get",
        },
        "*"
      );
    }
  });
};
